import { render, staticRenderFns } from "./solutionPre.vue?vue&type=template&id=45fd5e5c&scoped=true"
import script from "./solutionPre.vue?vue&type=script&lang=js"
export * from "./solutionPre.vue?vue&type=script&lang=js"
import style0 from "./solutionPre.vue?vue&type=style&index=0&id=45fd5e5c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd5e5c",
  null
  
)

export default component.exports